import { useQuery } from 'react-query'
import { listarVersoes, obterModeloPublicado } from '../../core/_requests'
import { useProtocoloAcoes } from '../../core/useProtocoloAcoes'
import { useEmpresaDaTela } from '../../core/useEmpresaDaTela'

/**
 * Versões do protocolo da empresa da tela, separadas em vigente (destaque) e demais (tabela), mais
 * o modelo publicado (só para quem pode criar rascunho a partir dele). Em cache pela chave: os
 * blocos da tela compartilham as mesmas requisições.
 */
export const useVersoesProtocolo = () => {
  const { idEmpresa } = useEmpresaDaTela()
  const { acoes } = useProtocoloAcoes(idEmpresa)

  const versoes = useQuery(
    ['protocolos-triagem', 'versoes', idEmpresa],
    () => listarVersoes(idEmpresa as number),
    { enabled: !!idEmpresa, retry: false }
  )
  const { data: modelo } = useQuery(
    ['protocolos-triagem', 'modelo-publicado'],
    () => obterModeloPublicado(),
    { enabled: acoes.podeCriarRascunho, retry: false }
  )

  const lista = versoes.data ?? []
  const vigente = lista.find((versao) => versao.situacao === 'VIGENTE')
  const demais = lista.filter((versao) => versao.situacao !== 'VIGENTE')

  return { ...versoes, idEmpresa, acoes, modelo, vigente, demais }
}
